// @flow
import dp3_4l1q1 from './l1q1';
import dp3_4l1q2 from './l1q2';
import dp3_4l1q3 from './l1q3';
import dp3_4l1q4 from './l1q4';
import dp3_4l1q5 from './l1q5';
import dp3_4l3q1 from './l3q1';
import dp3_4l3q2 from './l3q2';
import dp3_4l3q3 from './l3q3';
import dp3_4l3q4 from './l3q4';
import dp3_4l3q5 from './l3q5';
import dp3_4l3q6 from './l3q6';
import dp3_4l5q1 from './l5q1';
import dp3_4l5q2 from './l5q2';
import dp3_4l5q3 from './l5q3';
import dp3_4l5q4 from './l5q4';
import dp3_4l5q5 from './l5q5';
import dp3_4l5q6 from './l5q6';
import dp3_4l5q7 from './l5q7';
import dp3_4l7q1 from './l7q1';
import dp3_4l7q2 from './l7q2';
import dp3_4l7q3 from './l7q3';
import dp3_4l7q4 from './l7q4';
import dp3_4l7q5 from './l7q5';
import dp3_4l7q6 from './l7q6';
import dp3_4l7q7 from './l7q7';
import dp3_4l7q8 from './l7q8';
import dp3_4l7q9 from './l7q9';

const questions = {
    dp3_4l1q1,
    dp3_4l1q2,
    dp3_4l1q3,
    dp3_4l1q4,
    dp3_4l1q5,
    dp3_4l3q1,
    dp3_4l3q2,
    dp3_4l3q3,
    dp3_4l3q4,
    dp3_4l3q5,
    dp3_4l3q6,
    dp3_4l5q1,
    dp3_4l5q2,
    dp3_4l5q3,
    dp3_4l5q4,
    dp3_4l5q5,
    dp3_4l5q6,
    dp3_4l5q7,
    dp3_4l7q1,
    dp3_4l7q2,
    dp3_4l7q3,
    dp3_4l7q4,
    dp3_4l7q5,
    dp3_4l7q6,
    dp3_4l7q7,
    dp3_4l7q8,
    dp3_4l7q9
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat3.4/index.js